import React from 'react';
import { useTranslation } from 'react-i18next';
import OnePagerCompositionChart, { OnePagerCompositionChartProps } from './OnePagerCompositionChart';

const CompositionWalletCard = ({ isPdfExport = false, ...props }: OnePagerCompositionChartProps) => {
  const { t } = useTranslation();
  return (
    <div className={`compositionWallet${isPdfExport ? ' composition-wallet-pdf' : ''}`}>
      <div className="bar-chart-title">
        <h3 className="chart-title">{t('one_pager_report.portfolio_composition')}</h3>
        {!isPdfExport && <p>{t('one_pager_report.approved_amount_projects')}</p>}
      </div>
      <div className="content-one-page-barchart">
        <OnePagerCompositionChart {...props} isPdfExport={isPdfExport} />
      </div>
    </div>
  );
};

export default CompositionWalletCard;
